import { render } from "./App.vue?vue&type=template&id=5f2382b1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5f2382b1&lang=css"

import exportComponent from "C:\\Users\\LewisLi\\workitem\\th workspace\\th_fe\\tiffanyFE-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__